import {
  H1 as SH1,
  H2 as SH2,
  H3 as SH3,
  H4 as SH4,
  H5 as SH5,
  H6 as SH6,
  P as SP,
} from "./styles.ts";
import { Markdown } from "./markdown";

type TTypography = {
  children?: any | any[];
  [key: string]: any;
};

export const H1 = ({ children, ...props }: TTypography) => {
  return (
    <SH1 {...props}>
      <Markdown>{children}</Markdown>
    </SH1>
  );
};

export const H2 = ({ children, ...props }: TTypography) => {
  return (
    <SH2 {...props}>
      <Markdown>{children}</Markdown>
    </SH2>
  );
};

export const H3 = ({ children, ...props }: TTypography) => {
  return (
    <SH3 {...props}>
      <Markdown>{children}</Markdown>
    </SH3>
  );
};

export const H4 = ({ children, ...props }: TTypography) => {
  return (
    <SH4 {...props}>
      <Markdown>{children}</Markdown>
    </SH4>
  );
};

export const H5 = ({ children, ...props }: TTypography) => {
  return (
    <SH5 {...props}>
      <Markdown>{children}</Markdown>
    </SH5>
  );
};

export const H6 = ({ children, ...props }: TTypography) => {
  return (
    <SH6 {...props}>
      <Markdown>{children}</Markdown>
    </SH6>
  );
};

export const P = ({
                    children,
                    as,
                    ...props
                  }: {
  $small?: boolean;
  $bold?: boolean;
  $color?: "standard" | "light" | "lightest";
  $textAlign?: string;
} & TTypography) => {
  return (
    <SP
      {...props}
      as={as || "div"}
    >
      <Markdown>{children}</Markdown>
    </SP>
  );
};
